<div class="product-category prodList">
    <ul class="row">
      <ng-container *ngIf="products.length === 0 || products === undefined || products === null">
        <div class="empty-products h-small">
          <ng-container *ngIf="currentUrl != urlHomePage">
            <div class="non-page">
              <ng-container *ngIf="sortCd == 'Joint' || sortCd == 'Promotion'">
                <img src="./assets/img/comming.png" alt="현재 진행중인 일정이 없습니다.">
              </ng-container>
              <ng-container *ngIf="sortCd != 'Joint' && sortCd != 'Promotion'">
                <img src="./assets/img/comming01.png" alt="등록된 상품이 없습니다.">
              </ng-container>
          </div>
          </ng-container>
        </div>
    </ng-container>
    <!-- <ng-container *ngFor="let item of products | paginate: config; index as i"> -->
      <ng-container *ngFor="let item of products| paginate: config; index as i">
      <li class="col-6 col-md-4" [ngClass]="sortCd == 'Brand'?'':'col-lg-3'" title="{{item.pdtName}}">
        <div class="prodImg rounded">
          <a href="javascript:;" (click)="handleOnClickProductDetail(item);">
            <ng-container *ngIf="item.fileName === null || item.fileName === ''">
              <img src="./assets/img/noImage.jpg" alt="">
            </ng-container>
            <ng-container *ngIf="item.fileName !== null && item.fileName !== ''">
              <img [src]="urlWownet + item.filePath + item.fileName" alt="">
            </ng-container>
          </a>
          <div class="proSoldOut" *ngIf="item.pdtQty == 0 && item.stockYn == 'Y'">
            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="90" height="30" viewBox="0 0 90 30" fill="none">
                <rect x="0.5" y="0.5" width="89" height="29" rx="5.5" fill="#C0C0C0" fill-opacity="0.8" stroke="white"/>
                <path d="M17.183 12.9323C17.1057 12.1443 16.482 11.6851 15.4717 11.6851C14.4372 11.6851 13.857 12.1637 13.8522 12.8163C13.8425 13.5414 14.5822 13.8605 15.4378 14.0587L16.3273 14.2762C18.0242 14.6581 19.2859 15.5235 19.2907 17.1768C19.2859 18.9848 17.8743 20.1402 15.4572 20.1402C13.0691 20.1402 11.5414 19.0331 11.4883 16.9157H13.48C13.5477 17.9116 14.3405 18.4095 15.4378 18.4095C16.5159 18.4095 17.212 17.9116 17.2169 17.1671C17.212 16.4952 16.5981 16.1809 15.5249 15.9151L14.442 15.6492C12.7693 15.2431 11.7445 14.4116 11.7493 12.9517C11.7396 11.1581 13.3253 9.96409 15.491 9.96409C17.6809 9.96409 19.1312 11.1775 19.1554 12.9323H17.183ZM29.6537 15.0497C29.6537 18.279 27.6475 20.1354 25.0273 20.1354C22.3927 20.1354 20.401 18.2693 20.401 15.0497C20.401 11.8204 22.3927 9.96409 25.0273 9.96409C27.6475 9.96409 29.6537 11.8204 29.6537 15.0497ZM22.4894 15.0497C22.4894 17.1623 23.4949 18.3128 25.0273 18.3128C26.5598 18.3128 27.5702 17.1623 27.5702 15.0497C27.5702 12.9372 26.5598 11.7866 25.0273 11.7866C23.4949 11.7866 22.4894 12.9372 22.4894 15.0497ZM31.0895 20V10.0994H33.1441V18.2983H37.403V20H31.0895ZM42.1814 20H38.6911V10.0994H42.2152C45.198 10.0994 47.0205 11.9558 47.0205 15.0401C47.0205 18.134 45.198 20 42.1814 20ZM40.7456 18.2355H42.0944C43.9797 18.2355 44.9708 17.259 44.9708 15.0401C44.9708 12.8356 43.9797 11.864 42.104 11.864H40.7456V18.2355ZM60.7572 15.0497C60.7572 18.279 58.751 20.1354 56.1309 20.1354C53.4962 20.1354 51.5045 18.2693 51.5045 15.0497C51.5045 11.8204 53.4962 9.96409 56.1309 9.96409C58.751 9.96409 60.7572 11.8204 60.7572 15.0497ZM53.5929 15.0497C53.5929 17.1623 54.5984 18.3128 56.1309 18.3128C57.6633 18.3128 58.6737 17.1623 58.6737 15.0497C58.6737 12.9372 57.6633 11.7866 56.1309 11.7866C54.5984 11.7866 53.5929 12.9372 53.5929 15.0497ZM68.3228 10.0994H70.3822V16.529C70.3822 18.6948 68.7386 20.1402 66.2876 20.1402C63.8222 20.1402 62.193 18.6948 62.193 16.529V10.0994H64.2476V16.355C64.2476 17.5055 65.0549 18.3273 66.2876 18.3273C67.5204 18.3273 68.3228 17.5055 68.3228 16.355V10.0994ZM71.6227 11.8011V10.0994H79.7297V11.8011H76.6986V20H74.6586V11.8011H71.6227Z" fill="#F01827" fill-opacity="0.8"/>
            </svg> Oanh lock 8 aug 2023 -->
            <div class="wrap-soldout">
                <div class="text-soldout">SOLD OUT</div>
                <p class="text-note">임시 품절되었습니다.</p>
            </div>
          </div>
          <div class="prodDate" *ngIf="sortCd == 'Joint' || sortCd == 'Promotion'">
            <p>{{ item.saleSDate }} ~ {{ item.saleEDate }}</p>
          </div>
          <div class="prodHover" *ngIf="sortCd != 'Joint' && sortCd != 'Promotion'">
            <a href="javascript:;" (click)="handleOnclickAddWishList(item, i)">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.18 39.21" [ngClass]="wishYN[i]==='Y'?'prodWish':'prodNoWish'">
                <!-- <defs>
                  <style>.cls-1{fill:none;stroke:#ffffff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.5px;}.cls-2{fill:#ffffff;}</style>
                </defs> -->
                <g id="레이어_2" data-name="레이어 2">
                  <g id="image">
                    <path class="cls-1" d="M43.93,12.79A11.53,11.53,0,0,0,22.59,6.71,11.54,11.54,0,1,0,4.7,21L22.59,38,40.49,21A11.51,11.51,0,0,0,43.93,12.79Z"/>
                    <path class="cls-t" d="M32.72,7.69A1.53,1.53,0,0,0,33,7.63l-.14,0h.4c.34,0-.2-.06,0,0l.57.15.22.08c.2.07-.26-.13.06,0a5.18,5.18,0,0,1,.57.31L35,8.4s.36.29.09.06a9.3,9.3,0,0,1,1,.92l.24.28c-.22-.26,0,.05.07.11s.23.35.34.53l.16.32c0,.06.19.44.06.11.08.22.16.44.22.67a3.38,3.38,0,0,1,.08.34s0,.08,0,.13,0,.05,0-.12c.09.07,0,.59,0,.7s0,.11,0,.17c0-.19,0-.21,0-.07s0,.23-.08.35-.07.23-.11.34,0,.12,0,0a1.3,1.3,0,0,0-.08.17,1.28,1.28,0,0,0,.44,1.71,1.26,1.26,0,0,0,1.71-.45c1.77-3.63-.89-7.79-4.37-9.16a4.25,4.25,0,0,0-2.68-.19,1.25,1.25,0,1,0,.67,2.41Z"/>
                  </g>
                </g>
              </svg>
            </a>
            <a href="javascript:;" (click)="handleOnAddToCart(i)">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.15 51.02" class="prodNoWish">
                <!-- <defs>
                  <style>.cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.5px;}</style>
                </defs> -->
                <g id="레이어_2" data-name="레이어 2">
                  <g id="image">
                    <polyline class="cls-1" points="48.04 23.55 44.64 49.77 8.52 49.77 5.12 23.55"/>
                    <rect class="cls-1" x="1.25" y="15.11" width="50.65" height="7.73"/>
                    <line class="cls-1" x1="19.43" y1="1.25" x2="11.97" y2="14.31"/>
                    <line class="cls-1" x1="33.72" y1="1.25" x2="41.18" y2="14.31"/>
                    <line class="cls-1" x1="17.33" y1="30.04" x2="17.33" y2="41.44"/>
                    <line class="cls-1" x1="26.58" y1="30.04" x2="26.58" y2="41.44"/>
                    <line class="cls-1" x1="35.83" y1="30.04" x2="35.83" y2="41.44"/>
                  </g>
                </g>
              </svg>
            </a>
          </div>
        </div>
        <a href="javascript:;" class="pro-text-info" (click)="handleOnClickProductDetail(item);">
          <div class="prodTit">
            <p>{{ item.cateName }}</p>
            <h3 class="title-slide">{{ item.pdtName }}</h3>
            <span>{{ item.option1 }}</span>
          </div>
          <div class="prodInfo">
            <ng-container *ngIf="isLogin && !isConsumer || linkGuest =='Y' && !isConsumer">
              <ng-container *ngIf="item.cateNameOrg !== 'O06'">
                <div class="row align-items-center">
                  <div class="col-8 text-start">
                    <span class="consuPrice">{{ item.retailAmt | setComma }}원</span> |
                    <span class="discount">{{ item.rateAmtRetail | setComma }}%</span>
                  </div>
                  <div class="col-4 text-end" *ngIf="isPoint">
                      <span class="point">
                        {{ item.amtPoint | setComma }}
                        <span>P</span>
                      </span>
                    </div>
                </div>
                <div class="row align-items-center">
                  <div class="col-8 text-start">
                    <span class="price">{{ item.amt | setComma }}원</span>
                  </div>
                  <div class="col-4 text-end" *ngIf="loginInfo?.grpCD === GRP_AREKHAN">
                    <span class="price" *ngIf="isPv1">
                      {{ item.pv1 | setComma }}
                      <span>{{ smWowWord.oPv1 }}</span>
                    </span>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="item.cateNameOrg == 'O06'">
                <div class="row align-items-center">
                  <div class="col text-start">
                    <span class="point">{{ item.amt | setComma }}<span>P</span></span>
                  </div>
                  <div class="col text-end">
                      <span class="point">{{ item.amtPoint | setComma }}<span>P</span></span>
                  </div>
                </div>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="!isLogin && linkGuest =='N' || isConsumer">
                <div class="row align-items-center" *ngIf="item.cateNameOrg !== 'O06'">
                  <div class="col text-start">
                    <span class="price">{{ item.retailAmt | setComma }}원</span>
                  </div>
                  <div class="col text-end" *ngIf="isPoint">
                    <span class="point">
                      {{ item.retailAmtPoint | setComma }}
                      <span>P</span>
                    </span>
                  </div>
                </div>

                <div class="row align-items-center" *ngIf="item.cateNameOrg == 'O06'">
                  <div class="col text-start">
                    <span class="point">{{ item.retailAmtPoint | setComma }}<span>P</span></span>
                  </div>
                </div>
            </ng-container>
            <div class="prodTag">
              <span class="new" *ngIf="item.newYN === 'Y'">NEW</span>
              <span class="best" *ngIf="item.bestYN === 'Y'">BEST</span>
              <span class="recomm" *ngIf="item.recommYN === 'Y'">추천</span>
              <span class="hot" *ngIf="item.hotSaleYN === 'Y'">핫세일</span>
              <!-- <span class="deli">무료배송</span>
              <span class="coupon">COUPON</span> -->
            </div>
            <div class="row lineTag"> </div>
            <div class="prodReview">

              <fieldset class="starRate" disabled>
                <input type="radio" id="{{ 'pdt-rating10-' + i }}" name="{{ 'pdt-rating-' + i }}" [checked]="item.rating==10"><label for="{{ 'pdt-rating10-' + i }}" title="5점"></label>
                <input type="radio" id="{{ 'pdt-rating09-' + i }}" name="{{ 'pdt-rating-' + i }}" [checked]="item.rating==9"><label class="half" for="{{ 'pdt-rating09-' + i }}" title="4.5점"></label>
                <input type="radio" id="{{ 'pdt-rating08-' + i }}" name="{{ 'pdt-rating-' + i }}" [checked]="item.rating==8"><label for="{{ 'pdt-rating08-' + i }}" title="4점"></label>
                <input type="radio" id="{{ 'pdt-rating07-' + i }}" name="{{ 'pdt-rating-' + i }}" [checked]="item.rating==7"><label class="half" for="{{ 'pdt-rating07-' + i }}" title="3.5점"></label>
                <input type="radio" id="{{ 'pdt-rating06-' + i }}" name="{{ 'pdt-rating-' + i }}" [checked]="item.rating==6"><label for="{{ 'pdt-rating06-' + i }}" title="3점"></label>
                <input type="radio" id="{{ 'pdt-rating05-' + i }}" name="{{ 'pdt-rating-' + i }}" [checked]="item.rating==5"><label class="half" for="{{ 'pdt-rating05-' + i }}" title="2.5점"></label>
                <input type="radio" id="{{ 'pdt-rating04-' + i }}" name="{{ 'pdt-rating-' + i }}" [checked]="item.rating==4"><label for="{{ 'pdt-rating04-' + i }}" title="2점"></label>
                <input type="radio" id="{{ 'pdt-rating03-' + i }}" name="{{ 'pdt-rating-' + i }}" [checked]="item.rating==3"><label class="half" for="{{ 'pdt-rating03-' + i }}" title="1.5점"></label>
                <input type="radio" id="{{ 'pdt-rating02-' + i }}" name="{{ 'pdt-rating-' + i }}" [checked]="item.rating==2"><label for="{{ 'pdt-rating02-' + i }}" title="1점"></label>
                <input type="radio" id="{{ 'pdt-rating01-' + i }}" name="{{ 'pdt-rating-' + i }}" [checked]="item.rating==1"><label class="half" for="{{ 'pdt-rating01-' + i }}" title="0.5점"></label>
              </fieldset>
              <span> 평점 {{ item.grades | setComma }} </span>
              <p class="d-inline-block">
                  <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                          <g clip-path="url(#clip0_241_1642)">
                          <path d="M15 1.875C15 1.37772 14.8025 0.900806 14.4508 0.549175C14.0992 0.197544 13.6223 0 13.125 0L1.875 0C1.37772 0 0.900806 0.197544 0.549175 0.549175C0.197544 0.900806 0 1.37772 0 1.875L0 9.375C0 9.87228 0.197544 10.3492 0.549175 10.7008C0.900806 11.0525 1.37772 11.25 1.875 11.25H10.8619C11.1105 11.2501 11.3489 11.3489 11.5247 11.5247L14.1994 14.1994C14.2649 14.265 14.3484 14.3098 14.4393 14.328C14.5303 14.3462 14.6246 14.337 14.7103 14.3015C14.796 14.2661 14.8693 14.206 14.9209 14.1289C14.9724 14.0519 15 13.9612 15 13.8684V1.875ZM3.28125 2.8125H11.7188C11.8431 2.8125 11.9623 2.86189 12.0502 2.94979C12.1381 3.0377 12.1875 3.15693 12.1875 3.28125C12.1875 3.40557 12.1381 3.5248 12.0502 3.61271C11.9623 3.70061 11.8431 3.75 11.7188 3.75H3.28125C3.15693 3.75 3.0377 3.70061 2.94979 3.61271C2.86189 3.5248 2.8125 3.40557 2.8125 3.28125C2.8125 3.15693 2.86189 3.0377 2.94979 2.94979C3.0377 2.86189 3.15693 2.8125 3.28125 2.8125ZM3.28125 5.15625H11.7188C11.8431 5.15625 11.9623 5.20564 12.0502 5.29354C12.1381 5.38145 12.1875 5.50068 12.1875 5.625C12.1875 5.74932 12.1381 5.86855 12.0502 5.95646C11.9623 6.04436 11.8431 6.09375 11.7188 6.09375H3.28125C3.15693 6.09375 3.0377 6.04436 2.94979 5.95646C2.86189 5.86855 2.8125 5.74932 2.8125 5.625C2.8125 5.50068 2.86189 5.38145 2.94979 5.29354C3.0377 5.20564 3.15693 5.15625 3.28125 5.15625ZM3.28125 7.5H7.96875C8.09307 7.5 8.2123 7.54939 8.30021 7.63729C8.38811 7.7252 8.4375 7.84443 8.4375 7.96875C8.4375 8.09307 8.38811 8.2123 8.30021 8.30021C8.2123 8.38811 8.09307 8.4375 7.96875 8.4375H3.28125C3.15693 8.4375 3.0377 8.38811 2.94979 8.30021C2.86189 8.2123 2.8125 8.09307 2.8125 7.96875C2.8125 7.84443 2.86189 7.7252 2.94979 7.63729C3.0377 7.54939 3.15693 7.5 3.28125 7.5Z" fill="#7FBA7A"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_241_1642">
                          <rect width="15" height="15" fill="white"/>
                          </clipPath>
                          </defs>
                      </svg>
                  </span>
                  <span> {{ item.reviewsCnt | setComma }}</span>
              </p>
            </div>
          </div>
        </a>
      </li>
    </ng-container>
    </ul>
    <!-- <ng-container *ngIf="total > len"> -->
      <!-- <div class="pagination row" [ngClass]="totalPage > 1 ? 'paging-normal' : ''">
        <paging
          class="row paging"
          [len]="len"
          [page]="page"
          [config]="config"
          [totalItems]="total"
          (totalPage) = "handleOnTotalPage($event)"
          (changePage)="handleOnChangePage($event);"
        ></paging>
      </div> -->
    <!-- </ng-container> -->
  </div>
